import { createSlice } from '@reduxjs/toolkit'

// gameRoomSlice ========================================
export const gameRoomSlice = createSlice({
  name: 'gameRoom',
  initialState: {
    gameRoomDetails: [],
    roomStatus: '',
    lineupPlayers: [],
    formationId: '',
    lineupId: '',
    lineupName: '',
    hasJoined: false,
    activePopups: [],
    showParaWalletConnect: false,
    isEditLineup: false,
  },
  reducers: {
    setFormationId: (state, action) => {
      state.formationId = action.payload
    },
    setLineupId: (state, action) => {
      state.lineupId = action.payload
    },
    setLineupName: (state, action) => {
      state.lineupName = action.payload
    },
    setLineupPlayers: (state, action) => {
      state.lineupPlayers = action.payload
    },
    setGameRoomDetails: (state, action) => {
      state.gameRoomDetails = action.payload
    },
    setRoomStatus: (state, action) => {
      state.roomStatus = action.payload
    },
    setHasJoined: (state, action) => {
      state.hasJoined = action.payload
    },
    showActivePopup: (state, action) => {
      const popup = action.payload
      if (!state.activePopups.includes(popup)) {
        state.activePopups.push(popup)
      }
    },
    hideActivePopup: (state, action) => {
      const popup = action.payload
      if (popup) {
        state.activePopups = state.activePopups.filter((p) => p !== popup)
      } else {
        state.activePopups = []
      }
    },
    setIsEditLineup: (state, action) => {
      state.isEditLineup = action.payload
    },
  },
})

export const {
  setLineupId,
  setFormationId,
  setLineupName,
  setLineupPlayers,
  setGameRoomDetails,
  setRoomStatus,
  setHasJoined,
  showActivePopup,
  hideActivePopup,
  setIsEditLineup,
  setShowEditGround,
} = gameRoomSlice.actions

export default gameRoomSlice.reducer
